import {
  Box,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from '@chakra-ui/react';
import { FC } from 'react';
import { ExternalComplianceDrawer } from '~/apps/consumer/components/OrganizationCompliance/ComplianceDrawer/ExternalComplianceDrawer';
import { IngestionFoldersTableCard } from '~/apps/consumer/components/OrganizationCompliance/IngestionFoldersTable';
import { OrganizationComplianceFilters } from '~/apps/consumer/components/OrganizationCompliance/OrganizationComplianceFilters';
import {
  ComplianceTab,
  OrganizationCompliancePageProvider,
  useOrganizationCompliancePage,
} from './OrganizationCompliancePageContext';

export const OrganizationCompliancePageContent: FC = () => {
  const {
    folders,
    loading,
    error,
    fetchTriggerRef,
    hasActiveFilters,
    organizationId,
    selectedTab,
    setSelectedTab,
  } = useOrganizationCompliancePage();

  if (!organizationId) {
    return (
      <Box p={6}>
        <Text color="gray.500">No organization selected</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={6}>
        <Text color="red.500">
          Error loading ingestion folders: {error.message}
        </Text>
      </Box>
    );
  }

  return (
    <>
      <Flex direction="column" h="100vh" p={6}>
        <VStack align="stretch" flex="1" minH="0" spacing={4}>
          <Heading size="sm">Organization Compliance</Heading>
          <OrganizationComplianceFilters />
          <Tabs
            isLazy
            display="flex"
            flex="1"
            flexDirection="column"
            index={selectedTab === ComplianceTab.NEEDS_REVIEW ? 0 : 1}
            lazyBehavior="unmount"
            minH="0"
            onChange={(index) =>
              setSelectedTab(
                index === 0
                  ? ComplianceTab.NEEDS_REVIEW
                  : ComplianceTab.ALL_FOLDERS
              )
            }
          >
            <TabList>
              <Tab
                color={
                  selectedTab === ComplianceTab.NEEDS_REVIEW
                    ? 'compliance.text.primary'
                    : 'compliance.text.secondary'
                }
              >
                Needs Review
              </Tab>
              <Tab
                color={
                  selectedTab === ComplianceTab.ALL_FOLDERS
                    ? 'compliance.text.primary'
                    : 'compliance.text.secondary'
                }
              >
                All Folders
              </Tab>
            </TabList>
            <TabPanels display="flex" flex="1" flexDirection="column" minH="0">
              <TabPanel
                display="flex"
                flex="1"
                flexDirection="column"
                minH="0"
                p={0}
              >
                <IngestionFoldersTableCard
                  fetchTriggerRef={fetchTriggerRef}
                  folders={folders}
                  hasActiveFilters={hasActiveFilters}
                  loading={loading}
                />
              </TabPanel>
              <TabPanel
                display="flex"
                flex="1"
                flexDirection="column"
                minH="0"
                p={0}
              >
                <IngestionFoldersTableCard
                  fetchTriggerRef={fetchTriggerRef}
                  folders={folders}
                  hasActiveFilters={hasActiveFilters}
                  loading={loading}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </VStack>
      </Flex>

      <ExternalComplianceDrawer />
    </>
  );
};

export const OrganizationCompliancePage: FC = () => {
  return (
    <OrganizationCompliancePageProvider>
      <OrganizationCompliancePageContent />
    </OrganizationCompliancePageProvider>
  );
};
